const getDeedFeatureForDeedType = (deedType: string) => {
  switch (deedType) {
    case 'Campaign':
      return 'donations';

    case 'BaseEvent':
      return 'events';

    case 'Event':
    case 'Project':
    default:
      return 'volunteering';
  }
};

export default getDeedFeatureForDeedType;
